import type { HomeIconName } from "@ronin/contracts";
import {
  ActivityIcon,
  BellIcon,
  BookmarkIcon,
  BookOpenIcon,
  BotIcon,
  BoxesIcon,
  BoxIcon,
  CalendarDaysIcon,
  CameraIcon,
  CarIcon,
  ChartLineIcon,
  ClapperboardIcon,
  CloudDownloadIcon,
  CloudIcon,
  CodeXmlIcon,
  ContainerIcon,
  CpuIcon,
  DatabaseIcon,
  DownloadIcon,
  FileTextIcon,
  FilmIcon,
  FolderIcon,
  Gamepad2Icon,
  GaugeIcon,
  GitBranchIcon,
  GlobeIcon,
  HardDriveIcon,
  HeadphonesIcon,
  HeartIcon,
  HouseIcon,
  ImageIcon,
  KeyRoundIcon,
  LaptopIcon,
  LibraryIcon,
  LightbulbIcon,
  LinkIcon,
  LockIcon,
  type LucideIcon,
  MailIcon,
  MapIcon,
  MemoryStickIcon,
  MessageSquareIcon,
  MonitorIcon,
  MusicIcon,
  NetworkIcon,
  NewspaperIcon,
  NotebookPenIcon,
  PlaneIcon,
  PodcastIcon,
  PrinterIcon,
  RadioIcon,
  RouterIcon,
  RssIcon,
  SearchIcon,
  ServerIcon,
  SettingsIcon,
  ShieldCheckIcon,
  ShieldIcon,
  ShoppingCartIcon,
  SmartphoneIcon,
  SquareCheckBigIcon,
  StarIcon,
  TerminalIcon,
  ThermometerIcon,
  TvIcon,
  UploadIcon,
  UserIcon,
  UsersIcon,
  UtensilsIcon,
  WalletIcon,
  WifiIcon,
  WrenchIcon,
  ZapIcon,
} from "lucide-react";

/** spec12 FR11: the icons a link can use, keyed by the names the contracts allow. */
export const homeIcons: Record<HomeIconName, LucideIcon> = {
  globe: GlobeIcon,
  link: LinkIcon,
  house: HouseIcon,
  server: ServerIcon,
  database: DatabaseIcon,
  "hard-drive": HardDriveIcon,
  cloud: CloudIcon,
  "cloud-download": CloudDownloadIcon,
  router: RouterIcon,
  wifi: WifiIcon,
  network: NetworkIcon,
  shield: ShieldIcon,
  "shield-check": ShieldCheckIcon,
  lock: LockIcon,
  "key-round": KeyRoundIcon,
  container: ContainerIcon,
  box: BoxIcon,
  boxes: BoxesIcon,
  cpu: CpuIcon,
  "memory-stick": MemoryStickIcon,
  monitor: MonitorIcon,
  laptop: LaptopIcon,
  smartphone: SmartphoneIcon,
  tv: TvIcon,
  film: FilmIcon,
  clapperboard: ClapperboardIcon,
  music: MusicIcon,
  headphones: HeadphonesIcon,
  radio: RadioIcon,
  podcast: PodcastIcon,
  image: ImageIcon,
  camera: CameraIcon,
  "book-open": BookOpenIcon,
  library: LibraryIcon,
  newspaper: NewspaperIcon,
  rss: RssIcon,
  mail: MailIcon,
  "message-square": MessageSquareIcon,
  "calendar-days": CalendarDaysIcon,
  "square-check-big": SquareCheckBigIcon,
  "notebook-pen": NotebookPenIcon,
  "file-text": FileTextIcon,
  folder: FolderIcon,
  download: DownloadIcon,
  upload: UploadIcon,
  search: SearchIcon,
  "chart-line": ChartLineIcon,
  activity: ActivityIcon,
  gauge: GaugeIcon,
  terminal: TerminalIcon,
  "code-xml": CodeXmlIcon,
  "git-branch": GitBranchIcon,
  wrench: WrenchIcon,
  settings: SettingsIcon,
  bot: BotIcon,
  lightbulb: LightbulbIcon,
  thermometer: ThermometerIcon,
  zap: ZapIcon,
  printer: PrinterIcon,
  "gamepad-2": Gamepad2Icon,
  "shopping-cart": ShoppingCartIcon,
  wallet: WalletIcon,
  bell: BellIcon,
  star: StarIcon,
  heart: HeartIcon,
  bookmark: BookmarkIcon,
  users: UsersIcon,
  user: UserIcon,
  plane: PlaneIcon,
  car: CarIcon,
  map: MapIcon,
  utensils: UtensilsIcon,
};
